var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightIcon = function SvgArrowRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.94 8 9.47 3.53l1.06-1.06L16.06 8l-5.53 5.53-1.06-1.06L13.94 8Z",
    fill: "#fff"
  })));
};
export default SvgArrowRightIcon;